<template>
  <div class="main">
    <el-button icon="el-icon-arrow-left" @click="toReturn">返回</el-button>
    <div class="video flex flex-direction-column">
      <div style="min-height: 0px" class="flex flex-align-start flex-1">
        <div class="video-js" id="my-video" v-loading="loadingShow"></div>
        <div class="video-list flex-1">
          <div class="tab_view">
            <div :class="state == 0 ? 'blue1' : ''" @click="state = 0">
              视频列表
            </div>
            <div :class="state == 1 ? 'blue1' : ''" @click="state = 1">
              考点详解
            </div>
          </div>
          <ul class="chapterView" v-if="state == 0 && oneState == 0">
            <li
              v-for="(item, index) in catalogueData"
              :key="index"
              @click="getVideoChapter(item, index)"
            >
              <p :class="key == item.bookID ? 'blue' : ''">
                {{ item.bookName }}
              </p>
              <!-- <img src="@/assets/play.png" alt="" v-if="key == item.bookID" /> -->
              <ul
                class="joint_view"
                v-if="item.expand == true && item.children"
              >
                <li>
                  <el-tree
                    :data="item.children"
                    :props="defaultProps"
                    node-key="id"
                    :default-expanded-keys="[defaultID]"
                    @node-click="handleNodeClick"
                    :highlight-current="true"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span
                        :class="
                          data.videoType && rowId == data.id ? 'blue' : ''
                        "
                        >{{ node.label }}</span
                      >
                      <span v-if="data.videoType && rowId == data.id">
                        <img
                          src="@/assets/play.png"
                          alt=""
                          style="width: 18px; height: 14px; margin-left: 24px"
                        />
                      </span>
                    </span>
                  </el-tree>
                </li>
                <!-- <li v-for="(zitem, zindex) in item.children" :key="zindex">
                  <p>{{ zitem.chapterName }}</p>
                  <ul class="small_joint" v-if="zitem.names">
                    <li v-for="(sitem, sindex) in zitem.names" :key="index">
                      <p>{{ sitem.summary }}</p>
                    </li>
                  </ul>
                </li> -->
              </ul>
            </li>
          </ul>
          <ul v-else-if="state == 0 &&oneState == 1" class="joint_view">
            <!-- 没有章 -->
            <li>
              <el-tree
                :data="jointArr"
                :props="defaultProps"
                node-key="id"
                :default-expanded-keys="[defaultID]"
                @node-click="handleNodeClick"
                :highlight-current="true"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span
                    :class="data.videoType && rowId == data.id ? 'blue' : ''"
                    >{{ node.label }}</span
                  >
                  <span v-if="data.videoType && rowId == data.id">
                    <img
                      src="@/assets/play.png"
                      alt=""
                      style="width: 18px; height: 14px; margin-left: 24px"
                    />
                  </span>
                </span>
              </el-tree>
            </li>
          </ul>
          <div v-else class="txt">
            <p v-html="KnowledgeText"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      loadingShow: false,
      // 定时提交
      timer: null,
      catalogueData: [], // 章
      defaultProps: {
        children: "children",
        label: "label",
        value: "id",
      },
      rowId: "",
      key: 27217,
      // 播放器实例
      player: null,
      state: 0,
      KnowledgeText: "",
      defaultID: "", // 默认初始化展开ID
      oneState: "", // 是否有章
      jointArr: [],
    };
  },
  props: ["cutcoms"],
  activated() {
    this.init();
  },
  destroyed() {
    if (this.player) {
      this.player.pause();
      this.player.dispose();
    }
    clearTimeout(this.timer);
    this.timer = null;
  },
  mounted() {
    // 键盘事件
    document.onkeydown = (e) => {
      if ([37, 39].includes(e.keyCode)) {
        e.preventDefault();
        if (e.keyCode === 39) {
          this.setSeeTime(20);
        }
        if (e.keyCode === 37) {
          this.setSeeTime(-20);
        }
      }
    };
  },
  methods: {
    init() {
      this.oneState =  this.$parent.rowObj.oneState;
      if (this.oneState == 1) {
        // 没有章
        this.getvideoList('init')
        // this.getVideoChapter();
      } else {
        this.getVideoSort(); // 获取章节
      }
      //   this.getVideoChapter()
      //   this.openVideo()
    },
    // 返回
    toReturn() {
      this.$destroy();
      this.cutcoms(0);
      // this.$router.go(-1);
    },
    // 获取视频章节
    async getVideoSort() {
      const obj = {
        appID:  this.$parent.rowObj.appID,
      };
      const { data } = await ksPcApi.getVideoCatalogue(obj);
      if (data.Status == 200) {
        this.catalogueData = data.Data.map((item) => {
          item.state = false;
          item.expand = false;
          item.bookName = item.bookName.split("_")[0];
          return item;
        });
        // 初始化进来默认播放第一条视频
        let ix = 0;
        this.catalogueData.forEach((item, index) => {
          if (item.bookID ==  this.$parent.rowObj.bookID) {
            ix = index;
          }
        });
        this.getVideoChapter(this.catalogueData[ix], ix, "init");
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
    // 直接获取节
    async getvideoList(type) {
      const obj = {
        appEName:  this.$parent.rowObj.AppEName,
        bookID:  this.$parent.rowObj.bookID,
      };
      const { data } = await ksPcApi.videoChapter(obj);
      if (data.Status == 200) {
        this.jointArr = data.Data;
        this.jointArr.forEach((item) => {
            item.label = item.chapterName;
            item.children = item.names;
            item.id = item.chapterID;
            if (item.children) {
              item.children.forEach((zitem) => {
                zitem.label = zitem.summary;
              });
            }
          });
           if (type == "init") {
            // 初始化播放第一条
            let row = "";
            this.jointArr.forEach((item) => {
              if (item.chapterID ==  this.$parent.rowObj.chapterID) {
                if ( this.$parent.rowObj.id) {
                  item.children.forEach((zitem) => {
                    if (zitem.id ==  this.$parent.rowObj.id) {
                      row = zitem;
                    }
                  });
                } else {
                  row = item;
                }
              }
            });
            this.defaultID = row.id;
            this.handleNodeClick(row);
           }
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
    // 获取视频章下面的小节
    async getVideoChapter(val, index, type) {
      this.key = val.bookID;
      if (val.state == false) {
        const obj = {
          appEName:  this.$parent.rowObj.AppEName,
          bookID: val.bookID,
        };
        const { data } = await ksPcApi.videoChapter(obj);
        if (data.Status == 200) {
          this.catalogueData[index].state = true;
          this.catalogueData[index].children = data.Data;
          this.catalogueData[index].children.forEach((item) => {
            item.label = item.chapterName;
            item.children = item.names;
            item.id = item.chapterID;
            if (item.children) {
              item.children.forEach((zitem) => {
                zitem.label = zitem.summary;
              });
            }
          });
          this.rowId = this.catalogueData[index].children[0].names[0].id;
          this.catalogueData[index].expand = true;
          if (type == "init") {
            // 初始化播放第一条
            let row = "";
            this.catalogueData[index].children.forEach((item) => {
              if (item.chapterID ==  this.$parent.rowObj.chapterID) {
                if ( this.$parent.rowObj.id) {
                  item.children.forEach((zitem) => {
                    if (zitem.id ==  this.$parent.rowObj.id) {
                      row = zitem;
                    }
                  });
                } else {
                  row = item;
                }
              }
            });
            this.defaultID = row.id;
            this.handleNodeClick(row);
            return;
            // const row = this.catalogueData[0].children[0].children[0]
            //   ? this.catalogueData[0].children[0].children[0]
            //   : this.catalogueData[0].children[0];
            // this.defaultID = this.catalogueData[0].children[0].children[0]
            //   ? this.catalogueData[0].children[0].children[0].id
            //   : this.catalogueData[0].children[0].id;
            // this.handleNodeClick(row);
          }
        } else {
          this.$message.error(data.Msg || data.Data);
        }
      } else {
        this.catalogueData[index].expand = !val.expand;
      }
    },
    // 获取视频地址
    async handleNodeClick(row) {
      if (!row.children) {
        this.rowId = row.id;
        const obj = {
          nodeID: row.id,
          appID:this.$parent.rowObj.appID
        };
        if ( this.$parent.rowObj.newType) {
          obj.videoType =  this.$parent.rowObj.newType;
        }
        this.loadingShow = true;
        const { data } = await ksPcApi.getVideoPlayUrl(obj);
        if (data.Status == 200) {
          this.KnowledgeText = data.Data.KnowledgeText;
          if (this.player) {
            this.player.dispose();
          }
          setTimeout(() => {
            this.loadingShow = false;
          });
          this.openVideo(data.Data.playUrl);
        } else {
          this.$message.error(data.Msg || data.Data);
        }
      }
    },
    // 快进快退
    setSeeTime(time) {
      if (this.fastForward) return;
      this.fastForward = setTimeout(() => {
        const seeNum = this.getSeeInfo();
        this.player.seek(seeNum + time);
        clearTimeout(this.fastForward);
        this.fastForward = null;
      }, 300);
    },
    // 初始化视屏模块
    openVideo(url = "") {
      this.player = new Aliplayer(
        {
          id: "my-video",
          source: url,
          width: "800px",
          height: "600px",
          autoplay: false,
          isLive: false,
          rePlay: false,
          playsinline: true,
          WebView: "allowsInlineMediaPlayback",
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true,
          //进度条
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "cc",
              x: 30,
              y: 80,
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0,
            },
            {
              name: "infoDisplay",
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                { name: "progress", align: "blabs", x: 0, y: 44 }, //播放进度条
                { name: "playButton", align: "tl", x: 15, y: 12 }, //播放开始暂停按钮
                { name: "timeDisplay", align: "tl", x: 10, y: 7 }, //播放视频时间
                {
                  name: "fullScreenButton", //全屏按钮
                  align: "tr",
                  x: 10,
                  y: 10,
                },
                {
                  name: "volume", //音量
                  align: "tr",
                  x: 5,
                  y: 10,
                },
              ],
            },
          ],
        },
        (player) => {
          player.on("ready", () => {
            // 开始播放
            console.log("开始播放");
            player.play();

            // 播放完毕时触发
            // player.on("ended", () => {
            //   this.upData(this.parmasData);
            // });
          });
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 760px;
  padding: 24px;
  // 返回按键css
}
.video {
  padding: 20px;
  height: 100%;
  overflow: hidden;

  .video-js {
    width: 800px;
    height: 600px;
    background: #000;
    box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.1);
  }

  .video-list {
    height: 100%;
    overflow-y: auto;
    padding-left: 20px;
    min-width: 0px;

    .video-title {
      font-size: 18px;
      font-weight: bold;
      color: #343a40;
    }

    .list-box {
      min-height: 0px;
      overflow-y: auto;
      padding: 0 0.16rem;
    }

    .f-line {
      background: #eee;
      height: 0.12rem;
      width: 100%;
    }
  }

  ::v-deep .prism-big-play-btn {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
  }
}
.flex {
  display: flex;
}
.chapterView {
  margin-top: 24px;
  margin-left: 24px;
  overflow-y: auto;
  height: 500px;
  > li {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    cursor: pointer;
    > p {
      font-weight: bold;
    }
    > img {
      width: 20px;
      height: 16px;
      margin-left: 24px;
    }
  }
}
.joint_view {
  margin-left: 36px;
  > li {
    margin-top: 8px;
    > p {
      color: red;
    }
  }
}
.blue {
  color: #2d9aff;
}
ul {
  list-style: none;
}
.tab_view {
  width: 500px;
  height: 60px;
  //   margin-top: 24px;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 2px;
    &:nth-child(1) {
      border-right: 1px solid #ebecf1;
    }
  }
  border: 1px solid #ebecf1;
}
.blue1 {
  background: #ebf5ff;
  color: #2d9aff;
  font-weight: bold;
}
.txt {
  width: 500px;
  padding: 24px;
  height: 520px;
  overflow-y: scroll;
  > p {
    white-space: pre-wrap;
  }
}
</style>